import { render, staticRenderFns } from "./ImportMonitor.vue?vue&type=template&id=50846f60&scoped=true"
import script from "./ImportMonitor.vue?vue&type=script&lang=js"
export * from "./ImportMonitor.vue?vue&type=script&lang=js"
import style0 from "./ImportMonitor.vue?vue&type=style&index=0&id=50846f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50846f60",
  null
  
)

export default component.exports